export default __webpack_public_path__ + "static/media/close-icon.39c27386.svg";